import React from 'react';
import { Accordion, Box, H5, Icon, Link, Optional, useThemeContext } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import BreakdownSectionContent from './BreakDownSectionContent';
import themeStyles from './PriceBreakdownModalContent.styles';
import usePriceBreakdownGroups, { getBreakdownGroupContentValue } from './usePriceBreakdownGroups';
import { useLanguage } from '../../../utils/sitecoreContext';
const SectionHeading = themeStyles.apply(Box, 'SectionHeading');
const StyledBox = themeStyles.apply(Box, 'StyledBox');
const PrintLink = themeStyles.apply(Link, 'PrintLink');
const Title = themeStyles.apply(H5, 'Title');
const PriceBreakdownModalContent = ({ forPrint }) => {
    const language = useLanguage();
    const { t } = useTranslation();
    const { groups } = usePriceBreakdownGroups();
    const { borders, colors } = useThemeContext();
    return (React.createElement(Box, { "data-testid": "cy-price-breakdown-modal-content" }, groups.map(({ key, title, titleDataTestId, asAccordion, value, unit, content }, i) => {
        if (!(content === null || content === void 0 ? void 0 : content.length))
            return null;
        return (React.createElement(Box, { key: key },
            React.createElement(Optional, { when: !asAccordion },
                React.createElement(Box, { style: { marginTop: '32px' } },
                    React.createElement(SectionHeading, null,
                        React.createElement(Title, { "data-testid": titleDataTestId }, title),
                        i === 0 && (React.createElement(PrintLink, { href: true, styling: "tertiary2", my: "auto", "data-testid": "cy-price-breakdown-print-button", onClick: () => window.print() },
                            React.createElement(Box, { my: "auto", mr: "-6px" }, t('Shared.Common.printButton')),
                            React.createElement(StyledBox, { my: "auto", "data-testid": "cy-price-breakdown-print-icon" },
                                React.createElement(Icon, { width: "32px", name: "print", iconColor: "blue" }))))),
                    React.createElement(BreakdownSectionContent, { content: content, forPrint: forPrint }))),
            React.createElement(Optional, { when: asAccordion && !!(content === null || content === void 0 ? void 0 : content.length) },
                React.createElement(Box, { style: { marginTop: '32px' } },
                    React.createElement(Accordion, { defaultActiveItems: forPrint ? ['SectionGroupItem'] : undefined, iconName: "animatedArrowUpDown", isCompact: true, titleHasBorder: true, borderColor: "grey.3", hasBottomBorder: false, activeTitleHasBorder: false, itemsHaveTopBorder: false, titleStyles: { borderBottom: `${borders[3]} ${colors.grey[3]}` }, items: [
                            {
                                key: 'SectionGroupItem',
                                title: (React.createElement(SectionHeading, { disableBorder: true },
                                    React.createElement(Title, null, title),
                                    React.createElement(Title, null, getBreakdownGroupContentValue(value, unit, language)))),
                                content: React.createElement(BreakdownSectionContent, { content: content, forPrint: forPrint }),
                            },
                        ] })))));
    })));
};
export default PriceBreakdownModalContent;
